import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { wrapCollectionLayout } from "@quintype/components";
import { DfpAd } from "../../atoms/dfp-ad";
import { getType } from "../../../data/collection";
import SliderMain from "../../atoms/slider-main/index";
import SmallStoryCard from "../../atoms/small-story-card/index";
import SmallStoryCardDesktopVertical from "../../atoms/small-story-card-desktop-vertical/index";
import MagazineMainCard from "../../atoms/magazine-main-card/index";
import CollectionBundleItem from "../../atoms/collection-bundle-item";
import TrendingStories from "../../atoms/trending-stories";
import VideoStories from "../../atoms/video-stories";

import styles from "./styles.m.css";

const WrappedTrendingStories = wrapCollectionLayout(TrendingStories);
const WrappedVideoStories = wrapCollectionLayout(VideoStories);

const SliderCollectionStoriesBundle = ({ stories, collections, videoCollection }) => {
  return (
    <div className={styles["slider-collection-stories-bundle"]}>
      <div className={styles["slider-stories-wrap"]}>
        <SliderMain stories={stories.slice(0, 5)} />
      </div>
      <div className={styles["two-stories-wrap"]}>
        {stories &&
          stories
            .slice(5, 7)
            .map(story => story && <SmallStoryCard key={story.id} story={story} className={styles["story-card"]} />)}
        <WrappedVideoStories collection={videoCollection} className={`${styles["video-card"]}`} />
      </div>
      {collections && (
        <div className={styles["collections-wrap"]}>
          {collections
            .slice(0, 3)
            .map(
              collection =>
                collection && (
                  <CollectionBundleItem
                    key={collection.id}
                    collection={collection}
                    className={styles["collection-item"]}
                  />
                )
            )}
        </div>
      )}
    </div>
  );
};

SliderCollectionStoriesBundle.propTypes = {
  stories: SliderMain.propTypes.stories,
  collections: PropTypes.arrayOf(CollectionBundleItem.propTypes.collection),
  videoCollection: PropTypes.shape()
};

const FiveStories = ({ stories, collections }) => {
  return (
    <div className={styles["five-story-container"]}>
      <WrappedVideoStories
        collection={collections}
        className={`${styles["five-cards-item"]} ${styles["story-card-medium"]}`}
        storiesStart={1}
      />
      {stories &&
        stories
          .slice(0, 4)
          .map(
            story =>
              story && (
                <SmallStoryCardDesktopVertical
                  key={story.id}
                  story={story}
                  className={`${styles["five-cards-item"]} ${styles["story-card-small"]}`}
                />
              )
          )}
    </div>
  );
};

FiveStories.propTypes = {
  stories: SliderMain.propTypes.stories,
  collections: PropTypes.arrayOf(CollectionBundleItem.propTypes.collection)
};
FiveStories.storyLimit = 5;

const MainRow = ({ collection, accentColor, pagetype = "", magazine, config }) => {
  if (!collection.items) {
    return null;
  }
  const stories = collection.items.filter(item => item && item.type === "story").map(item => item.story);
  const collections = collection.items.filter(item => item && item.type === "collection");

  const collectionBundle = collections.filter(collection => getType(collection) === "bundle").slice(0, 3);
  const trendingCollection =
    collections.filter(collection => getType(collection) === "trending").slice(0, 1)[0] || null;
  const videoCollection = collections.filter(collection => collection.slug === "vikatan-videos").slice(0, 3)[0] || null;

  const [userType = "F", setType] = useState(false);
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      setType(user.userType);
    });
  }, []);

  return (
    <div className={styles["main-row"]} style={accentColor && { "--accent-color": accentColor }}>
      <div className={`container`}>
        <div className="row">
          {stories &&
            stories.length > 0 && (
              <SliderCollectionStoriesBundle
                stories={stories.slice(0, 7)}
                collections={collectionBundle}
                videoCollection={videoCollection}
              />
            )}
          {userType === "P" || userType === "T" || userType === "R" ? (
            " "
          ) : (
            <div className="widget300xauto">
              <DfpAd className={`${styles.ad}`} adtype="Rectangle" placement={pagetype} />
            </div>
          )}
          <WrappedTrendingStories collection={trendingCollection} className={styles["trending-stories"]} />
          {stories &&
            stories.length > 7 && <FiveStories stories={stories.slice(7, 12)} collections={videoCollection} />}
          {userType === "P" || userType === "T" || userType === "R" ? (
            <div className={`${styles["fullneet"]}`}>
              <fw-storyblock channel="vikatan" autoplay="true" />
            </div>
          ) : (
            <div className="widget300xauto-targetted">
              <div className="fw-storyblock-widget">
                <fw-storyblock channel="vikatan" autoplay="true" />
              </div>
            </div>
          )}
        </div>
      </div>
      {userType === "A" && <MagazineMainCard magazine={magazine} stories={stories} config={config} />}
    </div>
  );
};

MainRow.propTypes = {
  accentColor: PropTypes.string,
  collection: CollectionBundleItem.propTypes.collection,
  pagetype: PropTypes.string,
  magazine: PropTypes.array,
  config: PropTypes.shape()
};
MainRow.storyLimit = 17;

export default MainRow;
